import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'ce', 'Ce', [["path",{"d":"M9 6a6 6 0 1 0 0 12"}],["path",{"d":"M21 6a6 6 0 1 0 0 12"}],["path",{"d":"M15 12h6"}]]);